import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#424242"
      d="M0 2.5A2.5 2.5 0 0 1 2.5 0h7A2.5 2.5 0 0 1 12 2.5v7A2.5 2.5 0 0 1 9.5 12h-7A2.5 2.5 0 0 1 0 9.5z"
    />
  </svg>
);
export default SvgSquare;
